import { render } from "./Gender.vue?vue&type=template&id=581b4611&ts=true"
import script from "./Gender.vue?vue&type=script&lang=ts"
export * from "./Gender.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__